// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

var winWidth = $(window).width();

if ( winWidth > 991 ) {

  // init Swiper:
  const statsSwiper = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    autoHeight: false,
    speed:600,
    breakpoints: {
      // when window width is >= 640px
      640: {
        slidesPerView: 2.15,
      }
    }

  });

}

const logosSwiper = new Swiper('.logo-carousel--block', {
  //freeMode: true,
  loop: true,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  slidesPerView: 2,
  spaceBetween: 30,
  speed: 3000,
  breakpoints: {
    // when window width is >= 640px
    640: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 4,
    },
    1100: {
      slidesPerView: 5,
    },
    1400: {
      slidesPerView: 7,
    }
  }

});
